<template>
    <div class="inline-chat">
        <div class="chat-inner">
            <div class="sidebar">
                <card></card>
                <list></list>
            </div>
            <div class="main">
                <message></message>
                <inline-text></inline-text>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import card from 'components/card/card'
import List from 'components/list/list'
import Message from 'components/message/message'
import inlineText from 'components/inline-text/inline-text'

export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {
        card,
        List,
        Message,
        inlineText
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
    .inline-chat
        width: 100vw
        height: 100vh
        background: white
        position: fixed
        z-index: 500
        .chat-inner
            width: 60%
            height: 60vh
            border: 1px solid grey 
            margin: 60px auto
            .sidebar
                height: 100%
                float: left;
                width: 200px;
                color: #f4f4f4;
                background-color: #2e3238
            .main
                height: 100%
                position: relative;
                overflow: hidden;
                background-color: #eee;
</style>



// WEBPACK FOOTER //
// src/components/inline-chat/inline-chat.vue